/* import __COLOCATED_TEMPLATE__ from './past-conversation-link.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';
import { type PastConversationSnippetSearchResult } from 'embercom/lib/inbox2/copilot/types';

export interface PastConversationLinkArgs {
  conversation: PastConversationSnippetSearchResult['data']['conversation'];
  isIconLink?: boolean;
  inboxCategory?: string;
  inboxId?: string;
  onClickLink(event: PointerEvent): void;
}

interface Signature {
  Element: Element;
  Args: PastConversationLinkArgs;
  Blocks: {
    default: [];
  };
}

const PastConversationLink = templateOnlyComponent<Signature>();
export default PastConversationLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Copilot::Links::PastConversationLink': typeof PastConversationLink;
    'inbox2/Copilot/Links/past-conversation-link': typeof PastConversationLink;
  }
}
